import React, { PureComponent } from 'react';
import Paper from 'material-ui/Paper';
import moment from 'moment';
import Gravatar from 'react-gravatar';
import Formatter from '../../psuite-js/helpers/formatter';

class FilterListItem extends PureComponent {

    getFormattedAddress(lat, lng) {
        let url = `http://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true`;

        fetch(url).then(function(response) {
            console.log('response', response);
        });
    }

    componentDidMount() {

    }

    render() {

        const item = this.props.vehicle;
        const type = this.props.type;

        const user = item.user;
        const phones = user.phones;
        // const answer = item.answer;
        const date = item.date;
        const payload = item.payload;

        console.log('item', item.payload);

        const inRoute = (
            <div className="md-header-user filter-info">
                <small>
                    <i className={'material-icons'}>local_shipping</i> {item.id}
                </small>
                <small><i className={'material-icons'}>watch_later</i>  {moment(date).format('DD/MM/YYYY HH:mm')}</small>
            </div>
        );

        const inDelivery = (
            <div className="md-header-user filter-info">
                <small>
                    <i className={'material-icons'}>pin_drop</i> { payload && payload.customer_name }
                </small>
                <small><i className={'material-icons'}>watch_later</i>  {moment(date).format('DD/MM/YYYY HH:mm')}</small>
            </div>
        );

        return (
            <div className={'filter-item'}>
                <Paper>
                    <div className="monitoring-delivery-container" style={{'paddingTop': '20px'}}>
                        <div className="md-header">
                            <div className="md-header-user">
                                <div className="gravatar">
                                    <Gravatar email={user.email} size={48} default="mm" className="avatar" />
                                </div>
                                <div className="user-data">
                                    <h4>{ user.display_name }</h4>
                                    <small>{Formatter.formatPhone(phones.main)} / { item.id }</small>
                                </div>
                            </div>
                        </div>
                        <div className="md-header">
                            {
                                type === 'delivery_process' ? inDelivery : inRoute
                            }
                        </div>
                    </div>
                </Paper>
            </div>
        )
    }
}

export default FilterListItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/FilterListItem.js